import { MESSAGE_TYPES } from "../constants/message.constants";
import { determineMessageType } from "./determine-message-type";
import { MessageParsers } from "./message-parsers";
import { sortBySessionStart } from "./sort-by-session-start";
export const parseChatHistory = (chatHistory) => {
    return sortBySessionStart(chatHistory).reduce((acc, session) => {
        acc.push({
            type: MESSAGE_TYPES.SESSION_DIVIDER,
            startDate: new Date(session.sessionStart),
        });
        const transformedMessages = session.messages.map((message) => {
            const messageType = determineMessageType(message);
            return MessageParsers[messageType](message, message.sender);
        });
        acc.push(...transformedMessages);
        return acc;
    }, []);
};
//# sourceMappingURL=parse-chat-history.js.map